const SelfServeBuilderResponsesConstants = {
  SELF_SERVE_BUILDER_RESPONSES_NOTIFICATION_SET: 'SELF_SERVE_BUILDER_RESPONSES_NOTIFICATION_SET',
  SELF_SERVE_BUILDER_RESPONSES_GET_REQUEST: 'SELF_SERVE_BUILDER_RESPONSES_GET_REQUEST',
  SELF_SERVE_BUILDER_RESPONSES_GET_SUCCESS: 'SELF_SERVE_BUILDER_RESPONSES_GET_SUCCESS',
  SELF_SERVE_BUILDER_RESPONSES_GET_FAILURE: 'SELF_SERVE_BUILDER_RESPONSES_GET_FAILURE',
  SELF_SERVE_BUILDER_RESPONSES_CANCEL_REQUEST: 'SELF_SERVE_BUILDER_RESPONSES_CANCEL_REQUEST',
  SELF_SERVE_BUILDER_RESPONSES_CANCEL_SUCCESS: 'SELF_SERVE_BUILDER_RESPONSES_CANCEL_SUCCESS',
  SELF_SERVE_BUILDER_RESPONSES_CANCEL_FAILURE: 'SELF_SERVE_BUILDER_RESPONSES_CANCEL_FAILURE',
};

export const SelfServeBuilderResponsesNotifications = {
  success: 'Your document has been sent.',
  failure: 'Your request could not be completed. Please try again.',
};

export default SelfServeBuilderResponsesConstants;



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilderResponses/SelfServeBuilderResponsesConstants.jsx